export default defineNuxtRouteMiddleware((to, from) => {
    // const { $logger,$log } = useNuxtApp();
    // const log = import.meta.client ? $log : $logger;
    // log.info(`Navigating from ${from.fullPath} to ${to.fullPath}`);
  });